import { defineStore } from 'pinia'
import baseService, { triggerRedirect } from '@/utils/http/axios'
import { message } from 'ant-design-vue'
import { useRoutesList } from '@/store/routesList'

export const useLogin = defineStore('login', {
  state: () => ({
    userInfos: {},
    authBtnList: []
  }),
  actions: {
    setAuthBtnList(codeNos: string[]) {
      console.log(codeNos, 'codeNos')
      this.authBtnList = codeNos
    },
    getAuthBtnList() {
      return this.authBtnList
    },
    /**
     * 登录模块
     */
    // 获取加密用户名
    async getUserNamekey(data: String) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/auth/getKey?username=${data}`,
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 登录第一步账号密码接口
    async loginStepOne(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/auth/pcLoginStepOne',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 登录第二步手机验证码接口
    async loginStepTwo(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/auth/pcLoginStepTwo',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取用户信息
    async getUserInfo() {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/auth/info',
          method: 'get'
        }).then((res) => {
          const { treeMenu, freeze, roleType } = res.data
          if (roleType == 'admin') {
            this.userInfos = res.data
          } else {
            if (freeze == '0') {
              // message.error('当前用户已被禁用，请联系管理员')
              triggerRedirect()
            }
            if (!treeMenu || treeMenu.length <= 0) {
              message.error('暂无权限，请联系管理员')
              triggerRedirect()
            } else {
              this.userInfos = res.data
            }
          }
          resolve(res.data)
        })
      })
    },
    // 获取短信验证码
    async sendMsg(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: import.meta.env.MODE === 'production' ? '/console/base/sendMsg' : '/console/base/sendMsgTest',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取用户路由菜单
    async getAdminMenu(params?: object) {
      return new Promise(async (resolve, reject) => {
        return await baseService({
          url: '/console/user/getUserTreeMenu',
          method: 'get',
          params
        })
          .then((res) => {
            if (!res.data || res.data.length == 0 || (res.data.length == 1 && res.data[0].platformType == '2')) {
              message.error('暂无权限，请联系管理员')
              triggerRedirect()
            } else {
              const storesRoutesList = useRoutesList()
              storesRoutesList.setRoutesList(res.data)
              resolve(res.data)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 退出登录
    async logout() {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/auth/logout',
          method: 'post'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 首次登录修改密码
    async changePwd(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/auth/changePwd',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 修改密码
    async changePwdNeedOldPwd(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/auth/changePwdNeedOldPwd',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
